import { Component } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";

@Component({
    selector: 'app-goal-description-modal',
    templateUrl: './goal-description.modal.html',
    styleUrls: ['./goal-description.modal.scss']
})

export class GoalDescriptionModal {
    
    title: string;
    description: string;

    constructor(
        private _modalController: ModalController,
        private _navParams: NavParams
    ){
        this.title = this._navParams.get('title');
        this.description = this._navParams.get('description');
    }
    close(){
        this._modalController.dismiss();
    }

}